import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default class SlideTestimonials {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if ($('.event-testimonials__slideItem').length > 1) {
			this.swiper = new Swiper('.event-testimonials__slideActive', {
				loop: true,
				modules: [Pagination, Autoplay, EffectFade],
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				slidesPerView: 1,
				spaceBetween: 0,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				pagination: {
					el: '.event-testimonials__pagination',
					clickable: true,
					type: 'bullets'
				},
				breakpoints: {
					0: {
						slidesPerView: 1
					}
				}
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
